import { useRecoilState } from 'recoil';

import { preparedBudgetIdAtom } from '../atoms/preparedBudgetId';

export default function usePreparedBudgetId() {
  return useRecoilState(preparedBudgetIdAtom);
}
